module.exports = __webpack_public_path__ + "static/media/verified.yellow.5fc94085.svg";